import React from 'react';
import '../../components/CommonForBoth/rightbar.scss';

const RightSidebar = props => {
  return <React.Fragment></React.Fragment>;
};

export default RightSidebar;
